// extracted by mini-css-extract-plugin
export default {"contact-container":"contact_contact-container__GZtca","contact":"contact_contact__RIQzr","contact-items":"contact_contact-items__UaBSG"};